module.exports = __webpack_public_path__ + "static/img/product_images_big09_h5_zh.836ca04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big09_h5_zh.png
// module id = V7U+
// module chunks = 34